const NAVIGATION_URL = process.env.REACT_APP_LINKS_ENDPOINT!;

const BACKEND_ENDPOINT = process.env.REACT_APP_ENDPOINT!;
const KONAKART_ENDPOINT = process.env.REACT_APP_KONAKART_ENDPOINT!;

export { NAVIGATION_URL, BACKEND_ENDPOINT, KONAKART_ENDPOINT };
